module.exports = __webpack_public_path__ + "img/98.c0321730.jpg";